function log(...args) {
  console.log(...args)
}

log('this', 'is', 'sourcemaps')
